<div class="sidenav hidden md:flex flex-column" [class.collapsed]="isCollapsed">

  <!-- Logo header -->
  <div class="sidenav-header">
    <img src="assets/images/yaldi.svg" alt="Logo" [class.logo-sm]="isCollapsed" [class.logo-lg]="!isCollapsed" />
    <p-button styleClass="collapse-btn" [icon]="isCollapsed ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-left'"
      (onClick)="toggleCollapse()" [rounded]="true">
    </p-button>
  </div>

  <!-- Nav groups -->
  <div class="sidenav-scroll">
    <ng-container *ngTemplateOutlet="navGroups; context: { tooltip: isCollapsed }"></ng-container>
  </div>

  <!-- User profile footer -->
  <div class="sidenav-footer" [class.collapsed]="isCollapsed">
    <button type="button" class="user-avatar" (click)="!isCollapsed && userMenu.toggle($event)" (keydown.enter)="!isCollapsed && userMenu.toggle($event)" [style.cursor]="isCollapsed ? 'default' : 'pointer'">{{ employeeName.charAt(0) | uppercase }}</button>
    @if (!isCollapsed) {
    <button type="button" class="user-info" (click)="userMenu.toggle($event)" (keydown.enter)="userMenu.toggle($event)" style="cursor: pointer; text-align: left; background: none; border: none; padding: 0;">
      <div class="flex align-items-center gap-1">
        <span class="user-name">{{ employeeName }}</span>
        <i class="fa-solid fa-chevron-down" style="font-size: 10px; color: var(--text-secondary);"></i>
      </div>
      <span class="user-role">{{ employeeRole }}</span>
    </button>
    <button type="button" class="text-btn flex align-items-center" (click)="logout()">
      <img src="assets/icons/logout.svg" style="cursor: pointer;" alt="logout">
    </button>
    }
  </div>

  <p-menu #userMenu [model]="userMenuItems" [popup]="true" appendTo="body"></p-menu>
  <app-change-password-form [(visibility)]="showChangePassword"></app-change-password-form>
</div>

<!-- Mobile drawer -->
<p-drawer [(visible)]="drawerVisible" (visibleChange)="onDrawerVisibleChange($event)" position="left" [modal]="true"
  [showCloseIcon]="false" class="block md:hidden">
  <ng-template #headless>
    <div class="drawer-content">
      <div class="sidenav-header drawer-header flex justify-content-between mx-2">
        <img src="assets/images/yaldi.svg" alt="Logo" class="logo-lg" />
        <p-button class="drawer-close-btn" text="true" (onClick)="drawerVisible = false">
          <i class="fa fa-times" aria-hidden="true"></i>
        </p-button>
      </div>
      <div class="sidenav-scroll">
        <ng-container *ngTemplateOutlet="navGroups; context: { tooltip: false }"></ng-container>
      </div>
      <div class="sidenav-footer">
        <button type="button" class="user-avatar" (click)="userMenu.toggle($event)" (keydown.enter)="userMenu.toggle($event)" style="cursor: pointer;">{{ employeeName.charAt(0) | uppercase }}</button>
        <button type="button" class="user-info" (click)="userMenu.toggle($event)" (keydown.enter)="userMenu.toggle($event)" style="cursor: pointer; text-align: left; background: none; border: none; padding: 0;">
          <span class="user-name">{{ employeeName }}</span>
          <span class="user-role">{{ employeeRole }}</span>
        </button>
        <button type="button" class="text-btn flex align-items-center" (click)="logout()">
          <img src="assets/icons/logout.svg" style="cursor: pointer;" alt="logout">
        </button>
      </div>
    </div>
  </ng-template>
</p-drawer>

<!-- Shared nav groups template -->
<ng-template #navGroups let-tooltip="tooltip">

  @for (group of groups; track group.label) {
  @if (!tooltip) {
  <p class="nav-section-label">{{ group.label }}</p>
  }
  <ul class="nav-list">
    @for (item of group.items; track item.label) {
    <li>
      @if (item.routePath) {
      <a [routerLink]="item.routePath" class="nav-row" [class.active-route]="isActive(item)"
        [pTooltip]="tooltip ? item.label : ''" tooltipPosition="right">
        @if (item.icon) {
        <img [src]="item.icon" class="nav-icon" alt="" />
        }
        @if (!tooltip) {
        <span class="nav-label">{{ item.label }}</span>
        @if (item.badge) {
        <span class="nav-badge">{{ item.badge }}</span>
        }
        }
      </a>
      } @else {
      <button class="nav-row nav-group-header" [pTooltip]="tooltip ? item.label : ''" tooltipPosition="right"
        (click)="toggleItem(item)" (keyUp)="toggleItem(item)">
        @if (item.icon) {
        <img [src]="item.icon" class="nav-icon" alt="" />
        }
        @if (!tooltip) {
        <span class="nav-label">{{ item.label }}</span>
        @if (item.badge) {
        <span class="nav-badge">{{ item.badge }}</span>
        }
        <i class="fa-solid ml-auto chevron" [class.fa-chevron-down]="item.expanded"
          [class.fa-chevron-right]="!item.expanded"></i>
        }
      </button>
      }
    </li>
    }
  </ul>
  }
</ng-template>